import { Tooltip as TooltipAntd, Typography } from 'antd';
import styled from 'styled-components';

export const CardHistorico = styled.div`
  background: #f2f2f2;
  flex: 1;
  border-radius: 8px;
  padding: 15px;
  justify-content: center;
`;

export const TitleHistorico = styled.h1`
  color: #676a6c;
  font-size: 16px;
  font-weight: bold;
`;

export const TextValor = styled.h1`
  color: #676a6c;
  font-size: 16px;
  font-weight: bold;
  margin: 0;
`;

export const Text = styled(Typography.Text)`
  color: #676a6c;
  font-size: 14px;
  line-height: 24px;
`;

export const Tooltip = styled(TooltipAntd)`
  margin-left: 6px;
  border-radius: 6px;
`;
